import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTradingViewCandles: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTradingViewCandles"><Path d="M7.75 2H6.25V10H3V19H6.25V22H7.75V19H11V10H7.75V2Z" fill="currentColor"/><Path d="M17.75 2.00001H16.25V5H13V19H16.25V22H17.75V19H21V5H17.75V2.00001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTradingViewCandles;
